'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import {
  BookOpen,
  Rocket,
  FileText,
  ReceiptPoundSterling,
  Users,
  Calendar,
  HardHat,
  Sparkles,
  Settings,
  Smartphone,
  Plug,
  CreditCard,
  LifeBuoy,
  BellRing,
  type LucideIcon,
} from 'lucide-react';
import { Icon } from '@/components/ui/Icon';
import { HELP_CATEGORIES } from '@/lib/help/types';
import { helpPath } from '@/lib/help/href';

const CATEGORY_ICONS: Record<string, LucideIcon> = {
  'getting-started': Rocket,
  quotes: FileText,
  invoices: ReceiptPoundSterling,
  clients: Users,
  schedule: Calendar,
  'service-reminders': BellRing,
  engineers: HardHat,
  ai: Sparkles,
  settings: Settings,
  mobile: Smartphone,
  integrations: Plug,
  billing: CreditCard,
  troubleshooting: LifeBuoy,
};

export default function HelpSidebar() {
  const pathname = usePathname() ?? '';
  const introHref = helpPath('/');
  const onIntroduction = pathname === introHref;

  return (
    <nav className="help-sidebar" aria-label="Help navigation">
      <div className="help-sidebar-section-title">Get started</div>
      <ul className="help-sidebar-list">
        <li>
          <Link
            href={introHref}
            className={`help-sidebar-link${onIntroduction ? ' is-active' : ''}`}
          >
            <span className="help-sidebar-link-icon">
              <Icon icon={BookOpen} size={15} />
            </span>
            <span>Introduction</span>
          </Link>
        </li>
      </ul>

      <div
        className="help-sidebar-section-title"
        style={{ marginTop: 18 }}
      >
        Categories
      </div>
      <ul className="help-sidebar-list">
        {HELP_CATEGORIES.map((cat) => {
          const href = helpPath(`/${cat.slug}`);
          const active =
            pathname === href || pathname.startsWith(`${href}/`);
          const Glyph = CATEGORY_ICONS[cat.slug] ?? Sparkles;
          return (
            <li key={cat.slug}>
              <Link
                href={href}
                className={`help-sidebar-link${active ? ' is-active' : ''}`}
              >
                <span className="help-sidebar-link-icon">
                  <Icon icon={Glyph} size={15} />
                </span>
                <span>{cat.title}</span>
              </Link>
            </li>
          );
        })}
      </ul>

      <div className="help-sidebar-foot">
        Still stuck? Ask Mucka inside the app. Mucka knows your business.
      </div>
    </nav>
  );
}
